import { defineComponent, toRaw } from "vue";
import ChatItem, { ChatMessageJson } from "./items/Message";
import { AbstractChatItem, ItemKind } from "./ChatItem";
import Message from "./items/Message";
import Info from "./items/Info";
import Hello from "./items/Hello";
import Poll from "./items/Poll";

export default defineComponent({
    components: {
        ChatItem,

        Hello,
        Info,
        Message,
        Poll,
    },

    template: `
        <div class="ChatItems">
            <template v-for="item in items">
                <template v-if="isVisible(item)">
                    <template v-if="item.kind == 'message' && item.type == 80">
                        <Poll
                            :item="item"
                            :user="user"
                            :admin="admin"
                        />
                    </template>

                    <Message
                        v-else-if="item.kind == 'message'"
                        :message="item"
                        :user="user"
                        :admin="admin"
                        :moderated="moderated"
                    />

                    <component
                        v-else-if="item.kind != 'message'"
                        :is="getComponent(item)"
                        :item="item"
                    />
                </template>
            </template>
        </div>
    `,

    props: {
        items: { type: Array, required: true },
        user: { type: Object },
        admin: { type: Boolean },
        moderated: { type: Boolean },
        hideremoved: { type: Boolean },
    },

    methods: {
        getComponent(item: AbstractChatItem) {
            const names = {};
            names[ItemKind.HELLO] = Hello;
            names[ItemKind.INFO] = Info;

            return names[item.kind];
        },

        isVisible(item: AbstractChatItem) {
            if (item.kind == ItemKind.MESSAGE) {
                const msg = item as ChatMessageJson;

                if (!msg.type) {
                    return false;
                }

                if (this.admin) {
                    if (this.hideremoved) {
                        return !msg.removed;
                    } else {
                        return true;
                    }
                } else {
                    if (this.moderated) {
                        if (msg.owned) {
                            return true;
                        } else {
                            return !msg.removed;
                        }
                    } else {
                        return !msg.removed;
                    }
                }
            } else {
                return true;
            }
        },
    },
});
